(() => {
  const SECTION_SELECTOR = '.oddit-section-wine-club-pricing';

  function initSection(section) {
    const toggleGroups = section.querySelectorAll('.oddit-section-wine-club-pricing__toggle');
    for (const group of toggleGroups) {
      group.addEventListener('click', handleToggleClick);
    }

    const ctas = section.querySelectorAll('.oddit-section-wine-club-pricing__cta[data-bloom-join]');
    for (const cta of ctas) {
      cta.addEventListener('click', handleBloomCtaClick);
    }
  }

  function handleToggleClick(e) {
    const option = e.target.closest('.oddit-section-wine-club-pricing__toggle-option');
    if (!option) return;

    const group = option.closest('.oddit-section-wine-club-pricing__toggle');
    const card = option.closest('.oddit-section-wine-club-pricing__card');
    const allOptions = group.querySelectorAll('.oddit-section-wine-club-pricing__toggle-option');

    for (const opt of allOptions) {
      opt.classList.remove('oddit-section-wine-club-pricing__toggle-option--active');
      opt.setAttribute('aria-checked', 'false');
    }

    option.classList.add('oddit-section-wine-club-pricing__toggle-option--active');
    option.setAttribute('aria-checked', 'true');

    if (card) {
      const salePrice = option.getAttribute('data-price');
      const originalPrice = option.getAttribute('data-original-price');
      const discount = option.getAttribute('data-discount');
      const priceNote = option.getAttribute('data-price-note');
      const salePriceEl = card.querySelector('.oddit-section-wine-club-pricing__price-sale');
      const originalPriceEl = card.querySelector('.oddit-section-wine-club-pricing__price-original');
      const discountEl = card.querySelector('.oddit-section-wine-club-pricing__discount-badge');
      const priceNoteEl = card.querySelector('.oddit-section-wine-club-pricing__price-note');

      if (salePriceEl && salePrice) salePriceEl.textContent = salePrice;
      if (originalPriceEl && originalPrice) originalPriceEl.textContent = originalPrice;
      if (discountEl && discount) discountEl.textContent = discount;
      if (priceNoteEl && priceNote) priceNoteEl.innerHTML = priceNote;
    }
  }

  /**
   * Look up Bloom club data at runtime and store the membership selection
   * (including preferenceGroupId) before navigating to the join page.
   */
  function handleBloomCtaClick(e) {
    var cta = e.target.closest('.oddit-section-wine-club-pricing__cta[data-bloom-join]');
    if (!cta) return;

    var card = cta.closest('.oddit-section-wine-club-pricing__card');
    if (!card) return;

    var levelId = cta.getAttribute('data-bloom-level-id');
    console.log('levelId is: ', levelId);
    var joinUrl = cta.getAttribute('data-bloom-join-url');
    console.log('joinUrl is: ', joinUrl);
    if (!levelId || !joinUrl) return;

    /* Determine which toggle option is active (1-based data-option maps to rank) */
    var activeOption = card.querySelector('.oddit-section-wine-club-pricing__toggle-option--active');
    var targetRank = activeOption ? parseInt(activeOption.getAttribute('data-option'), 10) : 1;

    /* Look up the level from Bloom's runtime club data */
    if (typeof Bloom === 'undefined' || !Bloom.storefront || !Bloom.storefront.data) return;

    var clubs = Bloom.storefront.data.clubs;
    var membershipLevel = null;
    var parsedLevelId = parseInt(levelId, 10);

    for (var i = 0; i < clubs.length; i++) {
      var levels = clubs[i].levels;
      for (var j = 0; j < levels.length; j++) {
        if (levels[j].id === parsedLevelId) {
          membershipLevel = levels[j];
          break;
        }
      }
      if (membershipLevel) break;
    }

    if (!membershipLevel) return;

    /* Find the preference group whose value rank matches the selected toggle option.
       Groups with empty values are the "no selection" default — skip them.
       data-option="1" (6 bottles) → rank 1, data-option="2" (12 bottles) → rank 2 */
    var preferenceGroupId = null;
    var groups = membershipLevel.preferenceGroups;
    if (groups && groups.length > 0) {
      var selectedGroup = null;
      for (var g = 0; g < groups.length; g++) {
        if (groups[g].values && groups[g].values.length > 0 && groups[g].values[0].rank === targetRank) {
          selectedGroup = groups[g];
          break;
        }
      }
      if (!selectedGroup) {
        /* Fallback: first group with values */
        for (var g2 = 0; g2 < groups.length; g2++) {
          if (groups[g2].values && groups[g2].values.length > 0) {
            selectedGroup = groups[g2];
            break;
          }
        }
      }
      preferenceGroupId = selectedGroup ? selectedGroup.id : null;
    }

    /* Store in bloom storage */
    if (typeof bloom !== 'undefined' && bloom.storage) {
      e.preventDefault();

      var bloomStorage = bloom.storage();
      var membership = {
        membershipLevelId: parsedLevelId,
        frequencyId:
          membershipLevel.frequencies && membershipLevel.frequencies[0] ? membershipLevel.frequencies[0].id : null,
        selectionsAttributes: [],
        idempotencyKey: bloomStorage.getItem('membership.idempotencyKey') || generateHash(),
      };

      if (preferenceGroupId) {
        membership.preferenceGroupId = preferenceGroupId;
      }

      bloomStorage.setItem('membership', membership);
      window.location = joinUrl;
    }
  }

  /** Simple hash generator matching Bloom's pattern */
  function generateHash() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = (Math.random() * 16) | 0;
      return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
    });
  }

  function destroySection(section) {
    const toggleGroups = section.querySelectorAll('.oddit-section-wine-club-pricing__toggle');
    for (const group of toggleGroups) {
      group.removeEventListener('click', handleToggleClick);
    }

    const ctas = section.querySelectorAll('.oddit-section-wine-club-pricing__cta[data-bloom-join]');
    for (const cta of ctas) {
      cta.removeEventListener('click', handleBloomCtaClick);
    }
  }

  document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);

  document.addEventListener('shopify:section:load', (e) => {
    const section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });

  document.addEventListener('shopify:section:unload', (e) => {
    const section = e.target.querySelector(SECTION_SELECTOR);
    if (section) destroySection(section);
  });
})();
